import axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios'
import { router } from '@/router'

const axiosInstance: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_LOCA_CORE_BASE_URL
})

axiosInstance.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const token = window.localStorage.getItem('LOCA_PORTAL_ACCESS_TOKEN')
    if (token) {
      // @ts-ignore
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error))

// ADD A 401 RESPONSE INTERCEPTOR
axiosInstance.interceptors.response.use((response: AxiosResponse) => {
  return response
}, (error) => {
  if (error.response && error.response.status === 401 && error.response.config.url !== '/login') {
    window.localStorage.removeItem('LOCA_PORTAL_ACCESS_TOKEN')
    router.push('/login').catch((err: any) => { console.debug(err.message) })
  } else {
    return Promise.reject(error)
  }
})

export default axiosInstance
